<template>
  <div class="dicome-page">
    <div class="dicome-item">
      <div v-for="(item, index) in dicomeItem" :key="index" :class="item.class">
        {{ item.title }}
      </div>
    </div>
    <div v-for="(item, index) in dicomeList" :key="index" class="dicome-item">
      <div>{{ item.name }}</div>
      <div>{{ item.department }}</div>
      <div class="check-date">{{ item.studyDate }}</div>
      <div @click="onGoDicomDetail(item)">查看</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'dicomePage',
  props: ['dicomeList'],
  data() {
    return {
      dicomeItem: [
        { title: '患者姓名', class: '' },
        { title: '科室', class: '' },
        { title: '日期', class: 'check-date' },
        { title: '影像结果', class: '' },
      ]
    }
  },
  methods: {
    onGoDicomDetail(item) {
      location.href = item.dicomUrl;
    }
  }
}
</script>
<style lang="less" scoped>
.dicome-page {
  width: 100%;
  height: 100vh;
  background: #fff;

  .dicome-item {
    display: flex;

    div {
      line-height: 2.5em;
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #dddddd;

      &:nth-child(4n+1) {
        width: 1.5rem;
      }

      &:nth-child(4n+2) {
        width: 2.5rem;
      }

      &:nth-child(4n+3) {
        width: 2rem;
      }

      &:nth-child(4n+4) {
        width: 1.5rem;
      }
    }

    &:nth-child(odd) {
      background: #eeeeee;
    }
  }
}
</style>